import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LegOptionContext } from 'Modules/MultiStopWizard/Components/Leg/Contexts/LegOptionContext';
import { Button, Colors, Display } from 'Views/Components/Button/Button';

interface TripOptionChangeButtonProps {
	/** `Text` is the chosen card's underlined footer link; `Outline` the phone's full-width button. */
	display: Display;
}

/**
 * The way back to the sailing list.
 *
 * <p>Same handler as pressing the row again, because it is the same act — the sailing goes back to
 * being one of the day's options. It keeps the `change-selected-ticket` and leg-type class names the
 * old card carried, which is what the e2e flows and the step's own scroll-to-selection reach for.</p>
 */
export default function TripOptionChangeButton({ display }: TripOptionChangeButtonProps) {
	const context = React.useContext(LegOptionContext);

	if (!context) {
		console.error('LegOptionContext is missing in TripOptionChangeButton');
		return null;
	}

	const { legType, onClick } = context;
	const departure = legType === 'departure';

	return (
		<Button
			className={`trip-option__change ${
				departure ? 'departure-ticket' : 'return-ticket'
			} change-selected-ticket`}
			display={display}
			colors={Colors.Primary}
			newStyles={display === Display.Outline}
			onClick={onClick}
			buttonProps={{ 'data-test-id': `trip-option-change-${legType}` } as any}
		>
			{departure ? (
				<FormattedMessage
					id="trip-option__change-departing-trip__action"
					defaultMessage="Change departing trip time"
				/>
			) : (
				<FormattedMessage
					id="trip-option__change-returning-trip__action"
					defaultMessage="Change returning trip time"
				/>
			)}
		</Button>
	);
}
